import React from "react";
import "./multi-content-block.module.scss";

import { ButtonParser } from "components/button/ButtonParser";
import { Content } from "components/content/Content";
import { IContentBlock } from "components/content-blocks/content-blocks-types";
import { Image } from "components/image/Image";

interface MultiContentBlockProps {
  contentBlock: IContentBlock;
}

export const MultiContentBlock = ({
  contentBlock
}: MultiContentBlockProps) => {
  const {
    buttons,
    content,
    heading,
    image
  } = contentBlock;

  const prefix: string = 'fr-mcb';

  return (
    <div className={ prefix }>
      { image && image?.value.length > 0 && (
        <Image
          alt={ image.value[0].description }
          className={ `${prefix}__image` }
          image={ image.value[0] }
        />
      ) }

      <div className={ `${prefix}__wrapper` }>
        <div className={ `${prefix}__heading` }>
          { heading?.value && <h4 className={ `${prefix}__title` }>{ heading.value }</h4> }
        </div>
        { content && content?.value !== "<p><br></p>" && (
          <div className={ `${prefix}__content` }>
            <Content content={ content } />
          </div>
        ) }
        { buttons && buttons?.value?.length > 0 && (
          <div className={ `u-buttons-group ${prefix}__buttons` }>
            <ButtonParser buttons={ buttons.value } />
          </div>
        ) }
      </div>
    </div>
  )
}
